import { FaWhatsapp } from "react-icons/fa";

const WHATSAPP_URL =
  "https://api.whatsapp.com/send/?phone=27824947848&text=Hi%21+I%27d+like+to+know+more.&type=phone_number&app_absent=0";

function WhatsAppWidget() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg hover:bg-[#1ebe5b] hover:scale-110 transition duration-300"
    >
      <FaWhatsapp className="h-7 w-7" />
    </a>
  );
}

export default WhatsAppWidget;
